<template>
  <div v-if="getReviewTagsArr[0].conditionEvalCallback(explorerComponentThis) && reviewInfo" @click.stop.prevent="getReviewTagsArr[0].callback(getReviewTagsArr[0],explorerComponentThis)"  class="review-tag-styles w-100">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" width="16px" height="16px" viewBox="0 0 16 16" version="1.1">
        <title data-v-2dc8986a="">Review</title>
        <defs data-v-2dc8986a=""></defs>
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage"><g id="bug" sketch:type="MSArtboardGroup"><g id="Bug" sketch:type="MSLayerGroup" transform="translate(1.000000, 1.000000)">
        <rect id="Rectangle-36" fill="#008000" sketch:type="MSShapeGroup" x="0" y="0" width="14" height="14" rx="2" style="fill: #b7b228;"></rect>
        <path d="M10,7 C10,8.657 8.657,10 7,10 C5.343,10 4,8.657 4,7 C4,5.343 5.343,4 7,4 C8.657,4 10,5.343 10,7" id="Fill-2" fill="#FFFFFF" sketch:type="MSShapeGroup"></path></g></g></g>
      </svg>
      <span class="review-tag-name-styles">{{reviewInfo.review_tag}}<span v-if="requiredInfo && requiredInfo.includes('review_title')">: <span style="color:#eee">{{reviewInfo.review_title}}</span></span></span>
      <div v-if="requiredInfo && requiredInfo.includes('approver_ids') && reviewInfo.approver_ids && reviewInfo.approver_ids.length > 0" class="d-flex approvedUsers-wrapper"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="23" fill="#0dae0d" viewBox="0 0 16 16" class="bi bi-check-circle"><title>Approved</title><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path><path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"></path></svg></div>
      <span v-if="requiredInfo && requiredInfo.includes('review_status')" :class="reviewInfo.review_status && reviewInfo.review_status == 'Open'?'open-status':'closed-status'">{{reviewInfo.review_status && reviewInfo.review_status == 'Open'?'Open':'Closed'}}</span>
    </div>
</template>
  
<script>
  import {mapGetters} from "vuex";
  import Utils from '../../components.utils';

  export default {
    props: ['reviewInfo','requiredInfo'],
    computed: {
      selectedReviewTagInfo() {
        return this.reviewInfo;
      },
      ...mapGetters("registry", ['getReviewTagsArr']),
      ...mapGetters("users", ["getLoggedInUserPrivilege"]),
    },
    data() {
      return {
          explorerComponentThis:null,
      }
    },
    methods: {
      isEnabled(priv){
        return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege,priv)
      },
    },
    created() {
      this.explorerComponentThis = this;
    },
  }
</script>

<style lang="scss" scoped>
  .approvedUsers-wrapper {
    position: relative;
    top: 0px;
    width: fit-content;
    padding: 1px;
  }

  .user-name-or-image{
    width: 28px;
    height: 28px;
    margin-inline-start: 5px;
    top: 0px !important;
  }
  .review-tag-styles{
    width: fit-content !important;
    border: 1px solid #494949;
    padding: 3px 6px;
    border-radius: 10px;
    background: #23282a;
    display: flex;
    gap: 5px;
    align-items: center;
    cursor: pointer;
    margin-inline-end: 6px;
    margin-top: 6px;
    color: #dddddd;
    .review-tag-name-styles{
      color:#b7b228;
      position: relative;
      top: 1px;
    }
  }

  .review-tag-styles:hover{
    border: 1px solid #5c5c5c;
  }

  .review-tag-name-styles:hover{
    text-decoration: underline;
    text-decoration-color: #eee;
  }

  .open-status{
    color: #56c0ff;
    position: relative;
    top: 1px;
  }

  .closed-status{
    color: #5bc642;
    position: relative;
    top: 1px;
  }
</style>